import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations, LANGS } from "../lib/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "pt";
    const saved = window.localStorage.getItem("tvcabsat:lang");
    if (saved && translations[saved]) return saved;
    return "pt";
  });

  useEffect(() => {
    window.localStorage.setItem("tvcabsat:lang", lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      t: translations[lang] || translations.pt,
      langs: LANGS,
    }),
    [lang],
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
};
